export default function MissionSection() {
  return (
    <section
      data-testid="mission-section"
      className="py-24 sm:py-32 px-6"
      style={{ backgroundColor: "var(--blush)" }}
    >
      <div className="max-w-2xl mx-auto text-center">
        <p
          data-testid="mission-text"
          className="animate-fade-up"
          style={{
            fontFamily: "var(--font-serif)",
            fontStyle: "italic",
            fontSize: "clamp(1.2rem, 2.5vw, 1.55rem)",
            lineHeight: 1.75,
            color: "var(--charcoal)",
            fontWeight: 400,
          }}
        >
          "Most technology is built to capture your attention. We build
          technology to deepen your life. Every product we make asks one
          question: does this add genuine value to a real human being?"
        </p>
      </div>
    </section>
  );
}
